import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.svg';
import { useAuth } from '../context/AuthContext';
const LoginPage = () => {
    const { login, token } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || '/admin';
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            if (!response.ok) {
                throw new Error('Invalid credentials');
            }
            const data = await response.json();
            login(data);
            navigate(from, { replace: true });
        }
        catch (err) {
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    };
    if (token) {
        return _jsx(Navigate, { to: "/admin", replace: true });
    }
    return (_jsx("div", { style: {
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#000'
        }, children: _jsxs("form", { onSubmit: handleSubmit, style: {
                width: 'min(420px, 90vw)',
                padding: '2rem',
                borderRadius: '16px',
                border: '1px solid var(--color-border)',
                background: 'rgba(14, 13, 13, 0.9)',
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem'
            }, children: [_jsxs("div", { style: { textAlign: 'center' }, children: [_jsx("img", { src: logo, alt: "Boilerplate logo", style: { height: 48 } }), _jsx("h2", { children: "Boilerplate Status" })] }), _jsxs("div", { children: [_jsx("label", { children: "Username" }), _jsx("input", { value: username, onChange: (event) => setUsername(event.target.value), required: true })] }), _jsxs("div", { children: [_jsx("label", { children: "Password" }), _jsx("input", { type: "password", value: password, onChange: (event) => setPassword(event.target.value), required: true })] }), error && _jsx("div", { style: { color: 'tomato' }, children: error }), _jsx("button", { type: "submit", disabled: isLoading, children: isLoading ? 'Signing in...' : 'Sign in' }), _jsxs("p", { style: { fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)' }, children: ["Powered by: ", _jsx("strong", { children: "Boilerplate.com" })] })] }) }));
};
export default LoginPage;
